module.exports = __webpack_public_path__ + "static/media/renault.1283e278.png";